module.exports = __webpack_public_path__ + "img/hr-tree-05-d-leaves.77560156.png";